import React, { FC, SVGProps } from 'react';

export const Instagram: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill="#26313B" />
    <path
      d="M28.3652 13.2002H19.6347C16.0866 13.2002 13.2 16.0868 13.2 19.635V28.3654C13.2 31.9136 16.0866 34.8002 19.6347 34.8002H28.3652C31.9133 34.8002 34.8 31.9136 34.8 28.3654V19.635C34.7999 16.0868 31.9133 13.2002 28.3652 13.2002ZM32.627 28.3654C32.627 30.7191 30.7189 32.6272 28.3652 32.6272H19.6347C17.281 32.6272 15.3729 30.7191 15.3729 28.3654V19.635C15.3729 17.2812 17.281 15.3732 19.6347 15.3732H24H28.3652C30.7189 15.3732 32.627 17.2812 32.627 19.635V28.3654Z"
      fill="white"
    />
    <path
      d="M23.9999 18.4136C20.9194 18.4136 18.4133 20.9197 18.4133 24.0001C18.4133 27.0804 20.9194 29.5866 23.9999 29.5866C27.0803 29.5866 29.5864 27.0805 29.5864 24.0001C29.5864 20.9196 27.0803 18.4136 23.9999 18.4136ZM23.9999 27.4137C22.1146 27.4137 20.5863 25.8854 20.5863 24.0001C20.5863 22.1148 22.1146 20.5865 23.9999 20.5865C25.8851 20.5865 27.4134 22.1148 27.4134 24.0001C27.4134 25.8853 25.8851 27.4137 23.9999 27.4137Z"
      fill="white"
    />
    <path
      d="M29.5972 19.7945C30.3365 19.7945 30.9358 19.1951 30.9358 18.4558C30.9358 17.7165 30.3365 17.1172 29.5972 17.1172C28.8579 17.1172 28.2585 17.7165 28.2585 18.4558C28.2585 19.1951 28.8579 19.7945 29.5972 19.7945Z"
      fill="white"
    />
  </svg>
);
